import PathwayLessonVm, { CourseLessonVm } from '../models/LessonVm';

import Box from '@mui/material/Box';
import { ContentType } from '../models/Pathway';
import CourseLessonCard from './CourseLessonCard';
import { Disable } from 'react-disable';
import { LessonAttempt } from '../models/LessonAttempt';
import { LessonListSkeleton } from './LessonListSkeleton';
import PathwayLessonCard from './PathwayLessonCard';
import React from 'react';
import WithPathwayLessonLaunch from './WithPathwayLessonLaunch';

interface LessonListPanelProps {
  loading: boolean;
  title: string;
  courseLessons?: CourseLessonVm[];
  pathwayLessons?: PathwayLessonVm[];
  contentType: ContentType;
  filteredByStatus: boolean;
  onLaunchCourseLesson?: (
    lesson: CourseLessonVm,
    oldAttempt: LessonAttempt
  ) => void;
  onLaunchPathwayLesson?: (
    lessonWindow: Window,
    title: string,
    zonekey: number,
    pathkey: string,
    lessonkey: string,
    resultkey: string
  ) => void;
}

const LessonListPanel = (props: LessonListPanelProps) => {
  return (
    <div>
      <Box>
        {props.loading ? (
          <LessonListSkeleton
            direction="column"
            itemsCount={5}
            height={40}
            width={'100%'}
          />
        ) : props.contentType === 'course' ? (
          props.courseLessons?.map((lesson) => {
            const locked = lesson.moduleProgressStatus === 'L';
            return (
              <div key={lesson.lessonkey}>
                <Disable disabled={locked}>
                  <CourseLessonCard
                    lesson={lesson}
                    filteredByStatus={props.filteredByStatus}
                    onLaunchCourseLesson={props.onLaunchCourseLesson}
                  />
                </Disable>
              </div>
            );
          })
        ) : (
          props.pathwayLessons?.map((lesson) => {
            return (
              <div key={lesson.lessonkey}>
                <WithPathwayLessonLaunch
                  lesson={lesson}
                  filteredByStatus={props.filteredByStatus}
                  onLaunchPathwayLesson={props.onLaunchPathwayLesson}
                  LessonCardComponent={PathwayLessonCard}
                />
              </div>
            );
          })
        )}
      </Box>
    </div>
  );
};

export default LessonListPanel;
